import { transformSubsciberResponse } from './transform-subscriber';

export const transformRequestSubscriber = (values: transformSubsciberResponse): RequestReturn => {
  return {
    codice: Number.parseInt(values?.code || '') || undefined,
    descrizione: values?.description || undefined,
  };
};

interface RequestReturn {
  codice?: number;
  descrizione?: string;
}
